<template>
    <div class="page-class" v-if="isAccountLoaded">
        <nav-bar-logo
            class="history-nav"
            :userType="userType"
            :isBack="true"
            @clickBack="clickBack()">
        </nav-bar-logo>
        <div class="surprise-page surprise-open" ></div>
        <modal-master :controller="modalController" :theme="userType"></modal-master>
    </div>
</template>
<script>
//helper
import Account from '@/helper/AccountHelper.js';
//import Util from '@/helper/Utility.js';
//mixin
import AccountMixin from "@/mixin/AccountMixin.js";
import LocaleMixin from "@/mixin/LocaleMixin.js";
import ErrorApiMixin from '@/mixin/ErrorApiMixin.js';
//component
import NavBarLogo from "@/components/Layout/NavBar/NavBarLogo.vue";
// import SurpriseHeader from "../component/SurpriseHeader.vue";
//modal
import ModalMaster from "@/components/Modal/Component/ModalMaster.vue";
import { ModalController } from "@/components/Modal/Controller/ModalController.js";
import { AlertModalController } from "@/components/Modal/Controller/AlertModalController.js";
import { ConfirmModalController } from "@/components/Modal/Controller/ConfirmModalController.js";
import { LoadingModalController } from "@/components/Modal/Controller/LoadingModalController.js";
import { ConfirmSurpriseModalController } from "@/components/Modal/Controller/ConfirmSurpriseModalController.js";
import { ShippingModalController } from "@/components/Modal/Controller/ShippingModalController.js";
//service
import { ErrorHandler } from "@/core/ErrorApi/ErrorHandler.js";
//import BlobService from '@/core/BlobService/service/BlobService.js';
import BzbsCampaign from '@/core/Campaign/service/BzbsCampaign.js';
import { CampaignConfigBuilder } from "@/core/Campaign/model/CampaignConfigModel.js";
import SurpriseApi from '../service/SurpriseApi.js';
import BzbsAddress from '@/core/Address/service/BzbsAddress.js';
import BlobService from '@/core/BlobService/service/BlobService.js';

export default {
    name: 'SurpriseOpenBag',
    mixins: [AccountMixin, LocaleMixin, ErrorApiMixin],
    components: {
        ModalMaster,
        NavBarLogo,
        // SurpriseHeader,
    },
    computed: {
        userType: function () {
            return this.$store.state.userType;
        }
    },
    data: function() {
        return {
            campaignId: null,
            campaignConfig: null,
            campaign: null,
            redeemKey: null,
            //error handler
            errorHandler: null,
            //modal
            modalController: new ModalController(),
            alertModal: new AlertModalController(),
            confirmModal: new ConfirmModalController(),
            loadingModal: new LoadingModalController(),
            confirmSurpriseModal: new ConfirmSurpriseModalController(),
            shippingModal: new ShippingModalController(),
            //res: {"status":"Points","result":{"Name":"cpfsurprisebox1","Points":50,"Order":"0000000052","buzzebees":{"points":50,"updated_points":{"points":1246,"time":1650610468},"description":"","traces":[{"Id":"FortuneWheel","Current":1150,"Change":50,"Points":50,"ObjectId":null,"ValueResetReason":null,"UserDescription":null,"UserLevel":0,"CustomInfo":null,"LineMessageSetting":null}]}}},
            //res: {"status":"Campaign","result":{"CampaignId":147554,"ItemNumber":5,"Serial":"PZZW6ZF","AgencyId":197735,"AgencyName":"cpf_feed","CatId":9442723,"Name":"บัตร Swensen 100 บาท - surprise box","NextRedeemDate":null,"CurrentDate":1650620665,"RedeemCount":5,"UseCount":5,"Qty":99995.0,"IsConditionPass":true,"ConditionAlert":null,"IsNotAutoUse":false,"PointType":null,"InterfaceDisplay":null,"RedeemKey":"147554_5","PricePerUnit":0.00,"WalletCard":null,"NextRedeemDatePerCard":null,"RedeemCountPerCard":1,"UseCountPerCard":0,"CategoryDetail":"CPF Voucher\nบัตรกำนัล - free delivery","MasterCampaignName":null,"RedeemDate":1650620665,"CampaignName":"บัตร Swensen 100 บาท - surprise box","PointPerUnit":0.0,"ConvertPoints":null,"ConvertPrice":null,"ExpireIn":null,"PrivilegeMessage":null,"PrivilegeMessageEN":null,"PrivilegeMessageFormat":null,"buzzebees":{"traces":[{"Id":"Redeem","Current":18,"Change":1,"Points":0,"ObjectId":null,"ValueResetReason":null,"UserDescription":"Redeem Activities","UserLevel":0,"CustomInfo":null,"LineMessageSetting":null}]}}},
            //res: {"status":"Lose", "result":null},

            imgBag: null
        };
    },
    created: async function() {
        // this.getSurpriseBagImg();
        //modal
        this.modalController.setAlertModal(this.alertModal);
        this.modalController.setConfirmModal(this.confirmModal);
        this.modalController.setLoadingModal(this.loadingModal);
        this.modalController.setConfirmSurpriseModal(this.confirmSurpriseModal);
        this.modalController.setShippingModal(this.shippingModal);
        //error
        this.errorHandler = new ErrorHandler();
        this.errorHandler.setAlertModal(this.alertModal);

        let surprise = await this.getBlobConfig();
        if(!surprise) return;

        this.surpriseApi(surprise);
    },
    methods: {
        getBlobConfig: function(){
            return new Promise((resolve) => {
                BlobService.getSurpriseConfig()
                    .then(res => {
                        console.log('camp', res.data.name);
                        resolve(res.data.name);
                    }).catch(err => {
                        console.log(err);
                        resolve(null);
                    });
            })
        },
        getSurpriseBagImg: function(){
            return new Promise((resolve) => {
                BlobService.getSurpriseBagImg()
                    .then(res => {
                        this.imgBag = res;
                        resolve(res);
                    }).catch(err => {
                        console.log(err);
                        resolve(null);
                    });
            })
        },
        getCampaignDetail: function () {
            var token = Account.getToken();
            this.campaignConfig = new CampaignConfigBuilder()
                .setCampaignId(this.campaignId)
                .create();

            return new Promise((resolve) => {
                BzbsCampaign.apiGetCampaignDetail(token, this.campaignConfig)
                    .then(res => {
                        console.log('camp', res);
                        resolve(res);

                    }).catch(err => {
                        this.errorResponse(err, this.errorHandler);
                        resolve(null);
                    });
            });

        },
        surpriseApi: function(surprise){
            var token = Account.getToken();
            SurpriseApi.apiGetSurpriseBox(token, surprise)
                .then(res => {
                    console.log('res', res);

                    if(res.data.result){
                        this.redeemKey = res.data.result.RedeemKey;
                    }

                    var quantityFull =  res.data.status;
                    if (quantityFull == 'Full' || quantityFull == 'full') {
                        this.alertModal
                        .clearText()
                        .setTag('surprise-full')
                        .setMsg(this.lbl.surprise.msg_full)
                        .show();

                        this.alertModal.onClickOk((data) =>{
                            if(data.tag == 'surprise-full'){
                                window.location.replace('/');
                            }
                        });
                    }
                    this.openSurpriseModal(res.data);
                }).catch(err => {
                    this.loadingModal.hide();
                    let errMsg = '';
                    if (err.response && err.response.data && err.response.data.error) {
                        if (err.response.data.error.code == 409) {
                            errMsg = this.lbl.surprise.msg_err;
                        } else if (err.response.data.error.code == 404) {
                            errMsg = this.lbl.surprise.notfound;
                        } else if (err.response.data.error.code == 500) {
                            errMsg = this.lbl.surprise.err_500;
                        } else {
                            errMsg = err.response.data.error.message;
                        }
                        this.alertModal
                            .clearText()
                            .setTag('surprise-error')
                            .setMsg(errMsg)
                            .show();
                        this.alertModal.onClickOk((data) =>{
                            if(data.tag == 'surprise-error'){
                                window.location.replace('/');
                            }
                        });
                    }
                });
        },
        openSurpriseModal: async function(data){
            if(!data) return;

            let type = data.status.toLowerCase();
            let result = data.result;

            console.log('type', type);

            if(type == 'points'){
                this.confirmSurpriseModal
                    .clearModal()
                    .setTag('surprise-point')
                    .setPoint(result.Points)
                    .setBtnOk(this.lbl.surprise.btn_history)
                    .setBtnCancel(this.lbl.surprise.btn_close)
                    .show();

                this.confirmSurpriseModal.onClickConfirm((data) =>{
                    if(data.tag == 'surprise-point'){
                        window.location.replace('/history/earn');
                    }
                });
                this.confirmSurpriseModal.onClickCancel((data) =>{
                    if(data.tag == 'surprise-point'){
                        window.location.replace('/');
                    }
                });

            }else if(type == 'campaign'){
                this.campaignId = result.CampaignId;
                this.loadingModal.show();
                const campaign = await this.getCampaignDetail();

                this.loadingModal.hide();
                this.openConfirmSurprise(campaign);

            }else if(type == 'lose'){
                this.alertModal
                    .clearText()
                    .setTag('surprise-lose')
                    .setMsg(this.lbl.surprise.lose)
                    .setBtnOk(this.lbl.surprise.btn_close)
                    .show();

                this.alertModal.onClickOk((data) =>{
                    if(data.tag == 'surprise-lose'){
                        window.location.replace('/');
                    }
                });
            }

        },
        openConfirmSurprise: function(campaign){
            if(campaign.delivered){
                this.confirmSurpriseModal
                    .clearModal()
                    .setTag('surprise-campaign-delivery')
                    .setCampaign(campaign)
                    .setBtnOk(this.lbl.surprise.btn_success_confirm)
                    .setBtnCancel(this.lbl.surprise.btn_success_cancel)
                    .show();

                this.confirmSurpriseModal.onClickConfirm((data) =>{
                    if(data.tag == 'surprise-campaign-delivery'){
                        this.openShipping();
                    }
                });
                this.confirmSurpriseModal.onClickCancel((data) =>{
                    if(data.tag == 'surprise-campaign-delivery'){
                        window.location.replace('/');
                    }
                });

            }else{
                this.confirmSurpriseModal
                    .clearModal()
                    .setTag('surprise-campaign')
                    .setCampaign(campaign)
                    .setBtnOk(this.lbl.surprise.btn_history)
                    .setBtnCancel(this.lbl.surprise.btn_close)
                    .show();

                this.confirmSurpriseModal.onClickConfirm((data) =>{
                    if(data.tag == 'surprise-campaign'){
                        window.location.replace('/history/burn');
                    }
                });
                this.confirmSurpriseModal.onClickCancel((data) =>{
                    if(data.tag == 'surprise-campaign'){
                        window.location.replace('/');
                    }
                });
            }
        },
        openShipping: function(){
            this.shippingModal
                .clearModal()
                .setTitle(this.lbl.shipping.profile_headline)
                .setTag('edit-address-redeem')
                .setPage('surprisebox')
                .show();

            this.shippingModal.onSelected(address => {
                this.updateShipping(address);
            });

            this.shippingModal.onInternetError((err)=>{
                this.errorResponse(err, this.errorHandler);
            });
        },
        updateShipping: function(address){
            var addressItem = address.getParams();
            console.log('ads', addressItem);

            var redeemAddressConfig = {
                addressKey: addressItem.key,
            };

            //console.log('key', redeemAddressConfig);
            this.loadingModal.show();
            var token = Account.getToken();
            BzbsAddress.apiUpdateAddressAfterRedeem(token, this.redeemKey, redeemAddressConfig)
                .then(() => {
                    this.loadingModal.hide();
                    setTimeout(() => { 
                        this.updateShippingSuccess();
                     }, 300); 
                   
                }).catch(err => {
                    this.loadingModal.hide();
                    this.errorResponse(err, this.errorHandler);
                });
        },
        updateShippingSuccess(){
            let success_txt = this.lbl.surprise.delivery_success;
            this.confirmModal
                .clearText()
                .setTag('update-shipping-success')
                .setTitle(success_txt.title)
                .setMsg(success_txt.msg)
                .setBtnOk(success_txt.btn_ok)
                .setBtnCancel(success_txt.btn_cancel)
                .show();

            this.confirmModal.onClickOk((data) =>{
                if(data.tag == 'update-shipping-success'){
                    window.location.replace('/history/burn');
                }
            });

            this.confirmModal.onClickCancel((data) =>{
                if(data.tag == 'update-shipping-success'){
                    window.location.replace('/');
                }
            });
        },
        //event
        clickBack: function(){
            this.$router.push('/');
        }
    }
}
</script>
<style lang="scss" scoped>
@import "@/style/base/base.scss";
@import "@/style/base/common.scss";
@import "../style/SurpriseBox.scss";
</style>
